<template>
  <div>
    <div class="card abtg__default-card abtg__default-card-border abtg__air20">
      <div style="padding:20px; ">
        <p class="abtg__color-black-label ">In questa sezione puoi ripristinare gli immobili e le zone cancellate cliccando sul pulsante "ripristino"</p>
        <p><span class="abtg__focus-title">Gli immobili e le zone resteranno nel cestino per 120 giorni, poi verranno definitivamente eliminati

</span></p>
      </div>


      <div class="card-head">

        <header class="abtg__color-black-label ">
          <div class="row">
            <div class="col">
              <button
                  @click="showBuildings()"

                  class="btn btn-success  abtg__btn-third shadow-none abtg-button-big">IMMOBILI CANCELLATI
              </button>
            </div>
            <div class="col">
              <button
                  @click="showZones()"
                  class="btn btn-default  abtg__btn-second shadow-none abtg-button-big">ZONE CANCELLATE
              </button>
            </div>

          </div>


        </header>
        <div class="abtg__header_popover"></div>
        <div class="tools"></div>
      </div>
      <div class="card-body">
        <div class="table-responsive pb-4">

          <!-- IMMOBILI -->
          <table
              v-show="openBuildings"
            class="
              mdl-data-table
              ml-table-striped ml-table-bordered
              mdl-js-data-table
              is-upgraded
              abtg__table-noborder
            "
            style="min-height: 140px"
          >
            <thead>
              <tr class="d-flex">
                <th class="text-left col-1">N.</th>

                <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-2
                    align-middle
                  "
                >
                  <span class="abtg__text-abtg">{{
                    $t("operation.data_importazione")
                  }}</span>
                </th>
                <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-2
                    align-middle
                  "
                >
                  <span class="abtg__text-abtg">{{
                    $t("operation.data_cancellazione")
                  }}</span>
                </th>
                <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-3
                    align-middle
                  "
                >
                  <span class="abtg__text-abtg">{{
                    $t("operation.table_starred_address")
                  }}</span>
                </th>
                <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-2
                    align-middle
                  "
                >
                  <span class="abtg__text-abtg">{{
                    $t("operation.table_starred_city")
                  }}</span>
                </th>

                <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-1
                    align-middle
                  "
                >
                  <span class="abtg__text-abtg">{{
                    $t("operation.overview_label_mq")
                  }}</span>
                </th>

                <th class="mdl-data-table__cell--non-numeric
                    text-left
                    col-1
                    align-middle">
                    <span class="abtg__text-abtg">{{$t("operation.table_trash_restore")}}</span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(u, index) in buildingTrashed" class="d-flex">
                    <template v-if="u.my_zone">
                            <td class="col-1 text-center">
                              {{ index + 1 }}
                            </td>

                            <td class="col-2 abtg-ellipsis">
                              {{ u.created_at }}
                            </td>
                             <td class="col-2 abtg-ellipsis">
                              {{ u.deleted_at }}
                            </td>
                            <td class="col-3 abtg-ellipsis">
                              <a :href="u.link" target="_blank" style="color:blue;text-decoration: underline">{{ u.via }}</a><br>

                                <strong>Zone</strong>: {{ u.my_zone.zone }}<br>
                                <strong>Macrozone</strong>: {{ u.my_zone.macrozone }}<br>
                                <strong>Microzone</strong>: {{ u.my_zone.microzone }}<br>

                            </td>
                            <td class="col-2 abtg-ellipsis">
                              {{ u.my_city && u.my_city.comune }}
                            </td>
                            <td class="col-1 abtg-ellipsis">
                              {{ u.mq }}
                            </td>
                           <td class="col-1 abtg-ellipsis">

                                <button class="btn btn-default shadow-none abtg__btn-tool"

                                        @click="buildigsRestore({idToRestore: u.id})">
                              <i class="fas fa-angle-double-left"></i>
                                </button>


                           </td>
                    </template>
              </tr>
            </tbody>
          </table>


          <!-- ZONE -->

          <table
              v-show="openZones"
              class="
              mdl-data-table
              ml-table-striped ml-table-bordered
              mdl-js-data-table
              is-upgraded
              abtg__table-noborder
            "
              style="min-height: 140px"
          >
            <thead>
            <tr class="d-flex">
              <th class="text-left col-1">N.</th>

              <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-2
                    align-middle
                  "
              >
                  <span class="abtg__text-abtg">{{
                      $t("operation.data_importazione")
                    }}</span>
              </th>
              <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-2
                    align-middle
                  "
              >
                  <span class="abtg__text-abtg">{{
                      $t("operation.data_cancellazione")
                    }}</span>
              </th>
              <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-3
                    align-middle
                  "
              >
                  <span class="abtg__text-abtg">ZONE</span>
              </th>

              <th
                  class="
                    mdl-data-table__cell--non-numeric
                    text-left
                    col-3
                    align-middle
                  "
              >
                <span class="abtg__text-abtg">CITTA'</span>
              </th>

              <th class="mdl-data-table__cell--non-numeric
                    text-left
                    col-1
                    align-middle">
                <span class="abtg__text-abtg">{{$t("operation.table_trash_restore")}}</span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(u, index) in zoneTrashed" class="d-flex">
              <td class="col-1 text-center">
                {{ index + 1 }}
              </td>

              <td class="col-2 abtg-ellipsis">
                {{ u.created_at }}
              </td>
              <td class="col-2 abtg-ellipsis">
                {{ u.deleted_at }}
              </td>
              <td class="col-3 abtg-ellipsis">

                <strong>Zone</strong>: {{ u.zone }}<br>
                <strong>Macrozone</strong>: {{ u.macrozone }}<br>
                <strong>Microzone</strong>: {{ u.microzone }}<br>

              </td>
              <td class="col-2 abtg-ellipsis">
                {{ u.m_cities && u.m_cities.comune }}
              </td>

              <td class="col-1 abtg-ellipsis">

                <button class="btn btn-default shadow-none abtg__btn-tool"

                        @click="zoneRestore({idToRestore: u.id})">
                  <i class="fas fa-angle-double-left"></i>
                </button>


              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {mixin} from "@/helpers/helper";

export default {
  props: ["content"],
  mixins: [mixin],
  data() {
    return {
      'openBuildings' : true,
      'openZones' : false,
    };
  },
  created() {
    this.buildingsTrashed();
  },
  computed: {
    ...mapState("n_trash", ["buildingTrashed","message", "zoneTrashed"]),
  },
  methods: {
    ...mapMutations("n_trash", ["SET_DATA"]),
    ...mapActions("n_trash", ["buildingsTrashed","buildigsRestore", "zoneRestore"]),


    showBuildings() {
      this.openBuildings = true;
      this.openZones = false;
    },

    showZones(){
      this.openBuildings = false;
      this.openZones = true;
    }
  },
};
</script>
